export default __webpack_public_path__ + "static/media/Toro.2523c0e0.jpg";